import { AccountSectionData } from '@juvare/contact-management/backend/config/classifiers/AccountSectionClassifier/shared';

export const d550_backgroundCheck: AccountSectionData = {
    title: 'Background Check',
    name: 'Profile - Background Check',
    status: 'active',
    displayOrder: 550,
    showInPages: ['details', 'profile'],
    key: 'backgroundCheck',
};
